<script>
    import { createEventDispatcher, onMount } from "svelte";
    import { SetCDNImage, SetCDNImages } from "../common";
import { checkDataForUrls, checkUrls } from "../init";
    
    const dispatch =  createEventDispatcher()
    
    export let comp
    export let view
    export let height = screen.height;
    let search = false
    let metadata = null;
    let spectrum = false;
    let ready = false;
    
    onMount(()=>{
        

        

        // if(document.body && document.body.clientHeight && document.body.clientHeight > 0){
        //     height = document.body.clientHeight - 50;
        // }

        console.log(comp)
        console.log(view.d)
        console.log(view.id)
        console.log(view.c)

        switch(view.c){
            case 'image_gallery':
            case 'image_slideshow':
            case 'image_single':
            case 'image_zoom':
            case 'image_zoomable':
                let img;
                if(view.d && view.d.images && view.d.images.length > 0 && view.c !=='image_gallery' && view.c !=='image_slideshow'){
                    img = {source:view.d.images[0].source};
                }else{
                    if(view.d && view.d.length > 0 && view.c !=='image_gallery' && view.c !=='image_slideshow'){
                        img = view.d[0]
                    }else{
                        if(view.c === 'image_gallery' || view.c === 'image_slideshow'){
                            if(view.d && view.d.images){
                                img = view.d.images;
                            }else{
                                img = view.d;
                            }
                            SetCDNImages(img);
                        }else{
                            img = view.d;
                        }
                    }
                }
    
                if(img && img.source && img.source.url){
                    img.source.url = SetCDNImage(img.source.url);
                }
                view.d = img;
                console.log(view.d);
            break;

            case "content-block-rectangle":
            case "content-block-rectangle-rounded":
            case "other_contentblock1":
            case "other_contentblock2":
            case "other_contentblock3":
            case "other_contentblock4":
            case "other_contentblock1_button1":
            case "other_contentblock1_button2":
            case "other_contentblock2_button1":
            case "other_contentblock2_button2":
            case "other_contentblock3_button1":
            case "other_contentblock3_button2":
            case "other_contentblock9":
            case "other_contentblock10":
            case "other_contentblock11":
            case "other_contentblock12":
            case "other_contentblock13":
            case "other_contentblock14":
            case "square-content-block":

            case "rectangle-content-block":
            case "content-block":
            case "content_block1":
            case "content_block2":
            case "content_block3":
            case "content_block4":
            case "content_block1_button1":
            case "content_block1_button2":
            case "content_block2_button1":
            case "content_block2_button2":
            case "content-block-rounded":
        
            case "square-content-block-rounded":
            case "rectangle-content-block-rounded":
            case "rectangle-content-block-with-links":
            case "content_block5_square_button3":
            case "content_block4_html":
                
                    if (view.d.body && view.d.body!== undefined)
                    {
                        view.d.description = view.d.body;
                        view.d.body = "";
                    }
                    
                    if(view.d.header &&  view.d.header !== undefined){
                        view.d.image = view.d.header;
                        view.d.header = "";
                    }

                    console.log('content block')
                    console.log(view.d)        
                    if (view.d.sections && view.d.sections !== undefined)
                    {
                        console.log('sections found')
                        console.log(view.d.sections)
                        if (view.d.sections.length > 0)
                        {
                            console.log(view.d.sections[0]);
                            view.d.rows = view.d.sections[0].rows;
                            view.d.sections = null;
                        }
                    }
            break;
            
        }

        if(view.c.includes('map')){
            console.log('map data '+ view.d.parameters)
            view.d =view.d.parameters
        }

        if(view.c.includes('list') && !view.c.includes("menu")){
            if(view.d.rows !== undefined && view.d.rows && view.d.rows.length > 0){
                spectrum = false;
            }else{
                spectrum = true


                if(view.d.header !== undefined && view.d.header){
                    if(view.d.sections[0].rows && view.d.sections[0].rows.length>0){
                        view.d.sections[0].rows[0].header = view.d.header;
                    }
                }

            }

            if(view.d.search && view.d.search !== undefined){
                search = true;
            }
        }

        console.log(height);
        ready=true;
        dispatch('mounted', true)

        //check urls

        //content //list 
        if(view.c.includes('list') || view.c.includes('menu') || view.c.includes('content')  ){
            setTimeout(()=>{
                checkDataForUrls(view.d,view.c)
            },1000)
        }


    })
    
    //handle templates with extra stuff
	
</script>
{#if ready}
    {#if view.c.includes('list') && !view.c.includes("menu")}
        <svelte:component this="{comp}" data="{spectrum ? view.d.sections[0].rows:view.d.rows}" viewid="{view.id}"  template="{view.c}" {search} {metadata} {height} {spectrum}/>
    {:else}
        <svelte:component this="{comp}" data="{view.d}" viewid="{view.id}" template="{view.c}" {height}/>
    {/if}
{/if}